import { useState } from "react";
import { ShowToast } from "../../../../services/toast";
import { api } from "../../../../services/api";
import { PopupModal } from "../../../../components/PopupModal";
import { Button } from "../../../../components/Button";
import { TextArea } from "../../../../components/Textarea";
import { RbtRequest } from "../RequestRbt.types";

export function CancelRbtRequestConfirm({
  onCancel,
  onDelete,
  request,
}: {
  onCancel: () => void;
  onDelete: () => void;
  request: RbtRequest;
}) {
  const [deleting, setDeleting] = useState(false);
  const [cancellationReason, setCancellationReason] = useState("");
  const [reasonError, setReasonError] = useState("");

  const performDelete = async () => {
    // Validate cancellation reason
    if (!cancellationReason.trim()) {
      setReasonError("Cancellation reason is required");
      return;
    }
    
    try {
      setDeleting(true);
      const response = await api.deleteRbtRequest(request.id!, cancellationReason);
      if ([200, 201].includes(response.status)) {
        setDeleting(false);
        ShowToast({
          type: "success",
          message: "RBT Request Canceled!",
        });
      }
    } catch (error: any) {
      setDeleting(false);
      ShowToast({
        type: "error",
        message: error?.response?.data?.message || "Something went wrong",
      });
    }
    onDelete()
  };

  return (
    <PopupModal contentClassName="p-8 z-[2] w-[98%] self-center bg-white rounded-2xl flex-col justify-start items-center gap-6 flex w-full md:mx-auto md:w-[442px] max-w-[442px]">
      <div className="flex flex-col w-full">
        <p className="text-center text-xl text-black/80 font-medium">
          Are you sure you want to cancel RBT Request #{request.friendlyId}?
        </p>
        
        {/* Cancellation Reason Field */}
        <div className="flex flex-col mt-6">
          <span className="text-black/80 text-xs sm:text-sm mb-2">
            Reason for Cancellation <span className="text-red-500">*</span>
          </span>
          <TextArea
            placeholder="Please provide a reason for canceling this RBT request"
            className="!p-[14px] text-xs sm:text-sm"
            rows={3}
            value={cancellationReason}
            onChange={(e) => {
              setCancellationReason(e.target.value);
              setReasonError(""); // Clear error when user types
            }}
          />
          {reasonError && (
            <span className="text-red-500 text-xs mt-1">{reasonError}</span>
          )}
        </div>
        
        <div className="flex gap-3 items-center w-full mt-6">
          <Button
            onClick={onCancel}
            variant="outline"
            className="!rounded-full w-full flex-1"
            disabled={deleting}
          >
            Go Back
          </Button>
          <Button
            onClick={performDelete}
            className="!rounded-full w-full flex-1 bg-red-500 text-white"
            variant="primary"
            disabled={deleting}
            loading={deleting}
          >
            Cancel
          </Button>
        </div>
      </div>
    </PopupModal>
  );
}
